import { render, staticRenderFns } from "./SearchDropdown.vue?vue&type=template&id=8049451c&"
import script from "./SearchDropdown.vue?vue&type=script&lang=ts&"
export * from "./SearchDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports